module.exports = __webpack_public_path__ + "img/pregnantWoman.129830f6.png";